<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Solicitar redefinição de senha.</p>
    </header>
    <section class="modal-card-body">
      <div class="row">
        <div class="col-12">
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
          <app-input
            v-model="cpf"
            :errors="errors.cpf"
            label="Informe seu CPF"
            placeholder="Ex. 863.161.133-66"
            v-mask="'###.###.###-##'"
          ></app-input>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button
        @click="requestSolicitation()"
        :disabled="$v.$invalid || isSaving"
        v-app-button
      >
        Solicitar
      </button>
    </footer>
  </div>
</template>

<script>
import ClientService from '@/services/client.service';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'app-modal',
  data: () => {
    return {
      errors: {},
      cpf: null,
      isSaving: false,
      isLoading: false,
    };
  },
  validations: {
    cpf: { required },
  },
  methods: {
    requestSolicitation() {
      this.isLoading = true;

      const { cpf } = this;

      this.isSaving = true;
      ClientService.resetSolicitation(cpf.replace(/\D/g, ''))
        .then(() => {
          this.$buefy.dialog.alert({
            title: 'Solicitação realizada com sucesso!',
            message:
              'Enviamos um e-mail com as informações necessárias para redefinir sua senha.',
            type: 'is-success',
            onConfirm: () => this.$parent.close(),
          });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) {
            this.errors = errors;
          } else {
            this.toastify(message || 'Erro ao solicitar redefinição.', 'error');
          }
        })
        .finally(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-card {
  &-head {
    background: var(--color-secondary);

    p {
      color: #fff;
    }
  }

  &-body {
    h1 {
      font-family: var(--font-family-secondary);
      font-weight: 600;
      font-size: 2rem;
      color: var(--color-primary);
      text-align: center;
      margin-bottom: 8px;
    }

    p {
      font-size: 1.1rem;
      color: var(--text-color-medium);
      text-align: center;
      margin-bottom: 32px;
    }
  }
}
</style>
